import { Card, Col, Row, Statistic, Typography } from "antd";
import { useQuery } from "@tanstack/react-query";
import ReactECharts from "echarts-for-react";
import { api, DashboardData } from "../api";

const { Title } = Typography;

const CHAIN_COLORS: Record<string, string> = {
  ethereum: "#627EEA", bsc: "#F3BA2F", polygon: "#8247E5",
  solana: "#14F195", bitcoin: "#F7931A", ton: "#0098EA",
};

export default function Dashboard() {
  const { data } = useQuery({
    queryKey: ["dashboard"],
    queryFn: async () => (await api.get<DashboardData>("/dashboard")).data,
    refetchInterval: 30_000,
  });

  const m = data?.metrics;
  const posts7d = data?.posts_7d ?? [];
  const chainDist = data?.chain_dist ?? [];

  return (
    <div>
      <Title level={3} style={{ color: "#F5F5F7", marginTop: 0 }}>仪表盘</Title>

      <Row gutter={16} style={{ marginTop: 16 }}>
        <StatCard title="注册用户" value={m?.users ?? 0} suffix="人" />
        <StatCard title="近 7 日活跃设备" value={m?.active_devices_7d ?? 0} />
        <StatCard title="活跃群组" value={m?.groups ?? 0} />
        <StatCard title="今日新动态" value={m?.posts_today ?? 0} />
        <StatCard title="待处理举报" value={m?.pending_reports ?? 0} accent="#EF4444" />
        <StatCard title="今日红包" value={m?.red_packets_today ?? 0} accent="#22C55E" />
      </Row>

      <Row gutter={16} style={{ marginTop: 24 }}>
        <Col span={16}>
          <Card title="动态数(近 7 日)" style={cardStyle}>
            <ReactECharts
              style={{ height: 280 }}
              option={{
                tooltip: { trigger: "axis" },
                grid: { left: 32, right: 16, top: 16, bottom: 32 },
                xAxis: {
                  type: "category",
                  data: posts7d.map((d) => d.day),
                  axisLine: { lineStyle: { color: "#6B7280" } },
                },
                yAxis: { type: "value", axisLine: { lineStyle: { color: "#6B7280" } } },
                series: [
                  {
                    type: "line",
                    smooth: true,
                    data: posts7d.map((d) => d.count),
                    areaStyle: { color: "rgba(155,135,245,0.25)" },
                    lineStyle: { color: "#9B87F5", width: 2 },
                    itemStyle: { color: "#9B87F5" },
                  },
                ],
              }}
            />
          </Card>
        </Col>
        <Col span={8}>
          <Card title="红包链分布" style={cardStyle}>
            <ReactECharts
              style={{ height: 280 }}
              option={{
                tooltip: { trigger: "item" },
                series: [
                  {
                    type: "pie",
                    radius: ["55%", "80%"],
                    data: chainDist.map((c) => ({
                      value: c.count,
                      name: c.chain,
                      itemStyle: { color: CHAIN_COLORS[c.chain] ?? "#6B7280" },
                    })),
                    label: { color: "#A1A1AA" },
                  },
                ],
              }}
            />
          </Card>
        </Col>
      </Row>
    </div>
  );
}

const cardStyle = { background: "#10131A", border: "1px solid #1A1D26" };

function StatCard({ title, value, suffix, accent }: { title: string; value: number; suffix?: string; accent?: string; }) {
  return (
    <Col span={4}>
      <Card style={cardStyle}>
        <Statistic
          title={<span style={{ color: "#6B7280", fontSize: 12 }}>{title}</span>}
          value={value}
          suffix={suffix}
          valueStyle={{ color: accent ?? "#F5F5F7", fontWeight: 700 }}
        />
      </Card>
    </Col>
  );
}
